import Products_G_0 from './Products_G/Products_G_0'
import Products_G_1 from './Products_G/Products_G_1'
import Products_G_2 from './Products_G/Products_G_2'
import Products_G_3 from './Products_G/Products_G_3'
import Products_G_4 from './Products_G/Products_G_4'
import Products_G_5 from './Products_G/Products_G_5'
import Products_G_11 from './Products_G/Products_G_11'

const Products_G = [
  Products_G_0,
  Products_G_1,
  Products_G_2,
  Products_G_3,
  Products_G_4,
  Products_G_5,
  null,
  null,
  null,
  null,
  null,
  Products_G_11
]
export default Products_G



// WEBPACK FOOTER //
// ./src/components/Products_G.js